/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Menudietvegan2Inputs */

const en_menudietvegan2 = /** @type {(inputs: Menudietvegan2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`vegan`)
};

const de_menudietvegan2 = /** @type {(inputs: Menudietvegan2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`vegan`)
};

/**
* | output |
* | --- |
* | "vegan" |
*
* @param {Menudietvegan2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const menudietvegan2 = /** @type {((inputs?: Menudietvegan2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Menudietvegan2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_menudietvegan2(inputs)
	return de_menudietvegan2(inputs)
});
export { menudietvegan2 as "menuDietVegan" }